import { render } from "./TourForm.vue?vue&type=template&id=456a80c5"
import script from "./TourForm.vue?vue&type=script&lang=js"
export * from "./TourForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__